var _style, _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaterBottle01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1920",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        .st0{fill:#fff}.st1{fill:none;stroke:#231f20;stroke-width:50;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}\n    ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1124.6 432.7c-30.1 0-54.5-58.1-54.5-88.2 0-23.6-9.6-44.9-25-60.4s-36.8-25-60.4-25h-49.6c-47.2 0-85.4 38.2-85.4 85.4 0 15-6.1 37.1-16 55.4-9.9 18.3-23.5 32.8-38.5 32.8-3 0-5.7 1.2-7.7 3.2s-3.2 4.7-3.2 7.7v76.5h350.9v-76.5c.3-6-4.6-10.9-10.6-10.9zM960 417.8c-26.1 0-47.3-21.2-47.3-47.3 0-26.1 21.2-47.3 47.3-47.3s47.3 21.2 47.3 47.3c0 26.1-21.2 47.3-47.3 47.3z",
    id: "Layer_2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1222.9 781.8v853.6c0 37.4-30.3 67.6-67.6 67.6H764.8c-37.3 0-67.6-30.3-67.6-67.6V784.7c0-45.3 23-87.6 61.1-112.2l98.9-63.8v-88.6h217.1v88.6l91.3 63.5c35.9 24.9 57.3 65.8 57.3 109.6z",
    id: "Layer_4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "STROKES"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1070.2 344.5c0-47.2-38.2-85.4-85.4-85.4h-49.6c-47.2 0-85.4 38.2-85.4 85.4 0 30.1-24.4 88.2-54.5 88.2-6 0-10.8 4.8-10.8 10.8V520h350.9v-76.5c0-6-4.8-10.8-10.8-10.8-30 0-54.4-58.1-54.4-88.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 960,
    cy: 370.5,
    r: 47.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M857.1 520.1h217.1v88.6H857.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1222.9 781.8v853.6c0 37.3-30.3 67.6-67.6 67.6H764.7c-37.3 0-67.6-30.3-67.6-67.6V784.7c0-45.4 23-87.6 61.1-112.2l98.9-63.8h217.1l91.3 63.4c36 25 57.4 65.9 57.4 109.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M784.5 443.6h351"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterBottle01);
export default __webpack_public_path__ + "static/media/water-bottle-01.b6f1d6fa695c15d36c139b3bc39a58fb.svg";
export { ForwardRef as ReactComponent };